<template>
  <div class="section container">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <router-link to="/admin/cursos">Curso: {{breadcrumb.course}}</router-link>
        </li>
        <li class="is-active">
          <a href="#" aria-current="page">Módulos</a>
        </li>
      </ul>
    </nav>
    <button class="button m-b-md" @click="showModal = true">Adicionar</button>

    <b-table
      :data="data"
      :columns="columns"
      :paginated="true"
      per-page="10"
      current-page.sync="1"
      :pagination-simple="false"
      default-sort-direction="asc"
      default-sort="user.first_name"
      aria-next-label="Próxima pagina"
      aria-previous-label="Pagina anterior"
      aria-page-label="Page"
      aria-current-label="Pagina atual"
      detailed
      :opened-detailed="[1]"
      detail-key="_id"
      :show-detail-icon="true"
    >
      <template slot="detail" slot-scope="props">
        <article class="media">
          <div class="media-content">
            <div class="content">
              <b-button class="m-r-sm" type="is-primary" @click="edit(props)">Editar</b-button>

              <router-link
                class="button is-link m-r-sm"
                :to="{name: 'Lição', params:{ name: props.row._id, cur: $route.params.name }}"
              >Lições</router-link>

              <b-button type="is-danger" @click="confirm(props)">Remover</b-button>
            </div>
          </div>
        </article>
      </template>
    </b-table>

    <Modal
      :inputs="inputs"
      :active="showModal"
      :clear="clear"
      @functionByModal="addModule"
      @close="showModal = false"
    ></Modal>
    <Modal
      :inputs="editModule"
      :active="showModal2"
      :clear="clear"
      @functionByModal="update"
      @close="showModal2 = false"
    ></Modal>
  </div>
</template>

<script>
import Axios from "axios";

import Modal from "@/components/widgets/Modal";
export default {
  components: { Modal },
  data() {
    return {
      breadcrumb: {},
      showModal: false,
      showModal2: false,
      clear: false,
      columns: [
        {
          field: "name",
          label: "Nome",
          sortable: true
        },
        {
          field: "updatedAt",
          label: "Última alteração",
          sortable: true
        }
      ],
      inputs: [
        { label: "Título", type: "text", model: "name", required: true },
        {
          label: "Descrição",
          type: "textarea",
          model: "description"
        },
        {
          label: "Requer",
          type: "select",
          model: "requirement",
          content: this.data
        },
        {
          label: "Limite de vezes para fazer o exame",
          type: "number",
          model: "examLimit"
        },
        {
          label: "Menssagem do limite de vezes para fazer o exame",
          type: "text",
          model: "examLimitMessage"
        },
        {
          label: "Tempo do exame em minutos",
          type: "number",
          model: "examTime"
        },
        {
          label: "Porcentagem mínima para aprovação",
          type: "number",
          model: "totalToApprove"
        },
        {
          label: "Quantidade de questões para a prova",
          type: "number",
          model: "amountQuestion"
        },
        {
          label: "Ordenação",
          type: "number",
          model: "order"
        }
      ],
      data: [],
      editModule: []
    };
  },
  methods: {
    edit(data) {
      this.editModule = [
        {
          label: "Título",
          type: "text",
          model: "name",
          name: data.row.name,
          _id: data.row._id,
          required: true
        },
        {
          label: "Descrição",
          type: "textarea",
          model: "description",
          description: data.row.description
        },
        {
          label: "Requer",
          type: "select",
          model: "requirement",
          content: this.data,
          requirement: data.row.requirement
        },
        {
          label: "Limite de vezes para fazer o exame",
          type: "number",
          examLimit: data.row.examLimit,
          model: "examLimit"
        },
        {
          label: "Menssagem do limite de vezes para fazer o exame",
          type: "text",
          examLimitMessage: data.row.examLimitMessage,
          model: "examLimitMessage"
        },
        {
          label: "Tempo do exame em minutos",
          type: "number",
          model: "examTime",
          examTime: data.row.examTime,
          required: true
        },
        {
          label: "Porcentagem mínima para aprovação",
          type: "number",
          model: "totalToApprove",
          totalToApprove: data.row.totalToApprove,
          required: true
        },
        {
          label: "Quantidade de questões para a prova",
          type: "number",
          model: "amountQuestion",
          amountQuestion: data.row.amountQuestion,
          required: true
        },
        {
          label: "Ordenação",
          type: "number",
          model: "order",
          order: data.row.order,
        }
      ];
      this.showModal2 = true;
    },
    update(data) {
      let dados = Object.assign({}, data);
      dados = this.toNumber(dados);
      Axios.put(`/v1/modules/${this.editModule[0]._id}`, dados)
        .then(data => {
          if (data.data) {
            this.getModulos();
            this.showModal2 = false;
            this.$buefy.notification.open({
              message: "Dados atualizados com sucesso!",
              type: "is-success"
            });
          }
        })
        .catch(erro => {
          console.error(erro);
        });
    },
    remove(data) {
      Axios.delete(`/v1/modules/${data.row._id}`)
        .then(data => {
          if (data.data) {
            this.getModulos();
            this.$buefy.notification.open({
              message: "Curso excluido com sucesso!",
              type: "is-success"
            });
          }
        })
        .catch(erro => {
          console.error(erro);
        });
    },
    addModule(data) {
      let dados = Object.assign({}, data);
      dados.course = this.$route.params.name;
      dados = this.toNumber(dados);
      Axios.post(`/v1/modules/`, dados)
        .then(data => {
          if (data.data) {
            this.getModulos();
            this.showModal = false;
            this.$buefy.notification.open({
              message: "Modulo criado com sucesso!",
              type: "is-success"
            });
            this.clear = !this.clear;
          }
        })
        .catch(erro => {
          console.error(erro);
        });
    },
    getModulos() {
      Axios.get(`/v1/modules?course=${this.$route.params.name}`)
        .then(data => {
          if (data.data) {
            this.data = data.data.data;
            this.inputs[2].content = data.data.data;
            data.data.data.map((item, index) => {
              this.data[index].updatedAt = new Date(
                item.updatedAt
              ).toLocaleDateString("pt-BR");
            });
          }
        })
        .catch(erro => {
          console.error(erro);
        });
    },
    confirm(data) {
      this.$buefy.dialog.confirm({
        message: "Tem certeza que deseja <b>excluir</b> este módulo?",
        cancelText: "Cancelar",
        confirmText: "Confirmar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.remove(data)
      });
    },
    getCourse() {
      Axios.get(`/v1/courses/${this.$route.params.name}`)
        .then(data => {
          if (data.data) {
            this.breadcrumb.course = data.data.name;
            this.$forceUpdate(this.breadcrumb);
          }
        })
        .catch(erro => {
          console.error(erro);
        });
    },
    toNumber(item) {
      let dados = item;
      dados.order = dados.order * 1;
      dados.amountQuestion = dados.amountQuestion * 1;
      dados.totalToApprove = dados.totalToApprove * 1;
      dados.examTime = dados.examTime * 1;
      dados.examLimit = dados.examLimit * 1;
      return dados;
    }
  },
  mounted() {
    this.getModulos();
    this.getCourse();
  }
};
</script>

<style>
</style>
